import { NgModule } from '@angular/core';

import { CommonUIModule } from '../common-ui';

import { ListComponent, ListItemComponent } from './list';

@NgModule({
  declarations: [ListComponent, ListItemComponent],
  exports: [ListComponent, ListItemComponent],
  imports: [CommonUIModule],
})
export class ListModule {}
